import ButtonBlue from './ButtonBlue';

export default ButtonBlue;
